import * as React from 'react';
import  { withStyles } from '@mui/styles';

import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import * as classNames from 'classnames';
import {Toolbar} from '@mui/material';
import {Typography} from '@mui/material';
import {Icon} from '@mui/material';
import {IconButton} from '@mui/material';
import {Tooltip} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import {TextField} from '@mui/material';
import CookieManager from '~common/lib/cookie-manager'

const styles = (theme: Theme): StyleRules => ({
	container: {
		width: '100%'
	},
	root: {
		paddingRight: 2
	},
	spacer: {
		flex: '1 1 60%'
	},
	actions: {
		color: theme.palette.text.secondary
	},
	title: {
		flex: '0 0 auto'
	},
	filter: {
		paddingLeft: 30,
		paddingRight: 30
	},
	textField: {
		marginTop: 0,
		width: '100%'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	title: string;
	selectedItems: Array<any>;
	summaryActions?: Array<any>;
	onFilterTextChange?: (filterText: string) => void;
	onSubscribeClick?: () => void;
	onExportClick?: () => void;
	allowStickyFilter?: boolean
}

type State = {
	showFilter: boolean;
	filterText: string;
};

class SelectableTableToolbar extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			showFilter: false,
			filterText: ''
		};
	}

	componentDidMount(){
		if(this.props.allowStickyFilter){
			this.setState({
				showFilter: this.getDefaultFilterStatus()
			})
		}
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	setDefaultFilterStatus = (expanded: boolean) => {
		CookieManager.setCookie(window.location.pathname+'/defaultFilterBarStatus', expanded ? "open" : "closed", 30)
	}
	getDefaultFilterStatus = () :boolean => {
		return CookieManager.getCookie(window.location.pathname+'/defaultFilterBarStatus') == "open"
	}

	handleSummaryAction = (selected: Array<any>, fn: Function) => (event: any) => {
		fn(selected);
	};

	handleFilterTextChange = (event: any) => {
		this.setState({ filterText: event.currentTarget.value });

		if (this.props.onFilterTextChange) {
			this.props.onFilterTextChange(event.currentTarget.value);
		}
	};

	toggleFilter = (event: any) => {
		const self = this;
		this.setState(
			{ 
				showFilter: !this.state.showFilter, filterText: '' 
			}, function(){
				self.setDefaultFilterStatus(self.state.showFilter)
			});

		if (this.props.onFilterTextChange) {
			this.props.onFilterTextChange('');
		}
	};

	render() {
		const { classes }: { classes: ClassNameMap } = this.props;
		const { title, summaryActions, selectedItems, onExportClick, onSubscribeClick } = this.props;
		const { showFilter, filterText } = this.state;
		const numSelected = selectedItems.length;

		var actions ;
		if (numSelected > 0 && summaryActions) {
			actions = summaryActions.map((a, idx) => {
				return (
					<Tooltip key={a.key + idx.toString()} title={a.label}>
						<IconButton
							className={classes.actionButton}
							size="large"
							aria-label={a.label}
							onClick={this.handleSummaryAction(selectedItems, a.action)}
						>
							<Icon>{a.icon}</Icon>
						</IconButton>
					</Tooltip>
				);
			});
		} else {
			actions = [
				<Tooltip key="filter" title="Filter list">
					<IconButton  size="large" aria-label="Filter list" onClick={this.toggleFilter}>
						<FilterListIcon />
					</IconButton>
				</Tooltip>
			];
			if (onExportClick) {
				actions.push(
					<Tooltip key="export" title="Download list">
						<IconButton size="large" aria-label="Download list" onClick={onExportClick}>
							<Icon>file_download</Icon>
						</IconButton>
					</Tooltip>
				);
			}
			if (onSubscribeClick) {
				actions.push(
					<Tooltip key="subscribe" title="Subscribe to list">
						<IconButton aria-label="Subscribe to list" onClick={onSubscribeClick}>
							<Icon>mail</Icon>
						</IconButton>
					</Tooltip>
				);
			}
		}

		return (
			<div>
				<Toolbar
					className={classNames(classes.root, {
						[classes.highlight]: numSelected > 0
					})}
				>
					<div className={classes.title}>
						{numSelected > 0 ? (
							<Typography variant="subtitle1">{numSelected} selected</Typography>
						) : (
							<Typography variant="h6">{title}</Typography>
						)}
					</div>
					<div className={classes.spacer} />
					<div className={classes.actions}>{actions}</div>
				</Toolbar>
				{showFilter && (
					<div className={classes.filter}>
						<TextField
							autoFocus={true}
							id="filter"
							value={filterText}
							className={classes.textField}
							onChange={this.handleFilterTextChange}
							margin="normal"
							helperText="Type a word or phrase to filter results."
						/>
					</div>
				)}
			</div>
		);
	}
}

export default withStyles(styles)(SelectableTableToolbar);
